import { ReactNode } from "react";
import styled from "styled-components";
import { staticText } from "../../shared/statics/static-text";
import { primary01, shade0, shade800 } from "../../styles/tokens";

// TEXT
export const text = staticText.countBadge;

// STYLES
export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Badge = styled.span<{
  variant?: Variant;
  $size?: Size;
  $cutoff?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => ($size === "small" ? "1rem" : "1.25rem")};
  height: ${({ $size }) => ($size === "small" ? "1rem" : "1.25rem")};
  border-radius: 100%;
  background-color: ${({ variant }) =>
    variant === "primary" ? primary01 : shade800};
  color: ${shade0};
  padding-left: ${({ $cutoff }) => ($cutoff ? "1px" : "0")};
  font-size: ${({ $size, $cutoff }) =>
    $size === "small"
      ? $cutoff
        ? "0.6rem"
        : "0.75rem"
      : $cutoff
        ? "0.75rem"
        : "0.875rem"};
  font-weight: ${({ $size }) => ($size === "small" ? 500 : 700)};
  line-height: ${({ $size }) => ($size === "small" ? "1.25rem" : "1rem")};
  pointer-events: none;
`;

export const BadgeOverlay = styled(Badge)`
  position: absolute;
  top: ${({ $size }) => ($size === "small" ? "-0.5rem" : "-0.8rem")};
  right: ${({ $size }) => ($size === "small" ? "-0.625rem" : "-0.75rem")};
`;

// DATA

// TYPES
type Variant = "primary" | "secondary";
type Size = "small" | "normal";

export type Props = {
  count: number;
  children?: ReactNode;
  variant?: Variant;
  size?: Size;
};

// CONSTANTS
export const COUNT_CUTOFF = 9;

// FUNCTIONS

// ASSETS
